import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { questionValidation } from '../../functions/Validation';
import QuestionHelp from '../question/QuestionHelp';
import ValidationMessage from '../question/ValidationMessage';
import { tracking } from '../../functions/Tracking';
import { Action } from '../../enums/TrackingActionType';

export default function DateText(props: any) {

    const [question, setQuestion] = useState(props.question);
    const [dayValue, setDayValue] = useState("");
    const [monthValue, setMonthValue] = useState("");
    const [yearValue, setYearValue] = useState("");
    const [dateValue, setDateValue] = useState(question.answer);
    const [dateValueUpdated, setDateValueUpdated] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [secondsFocused, setSecondsFocused] = useState(0);
    const timerId = useRef<number>(0);

    let validationMessage = "Please enter a valid date";
    if (question.questionSetAnswerType.startRange !== "" && question.questionSetAnswerType.startRange !== null && question.questionSetAnswerType.startRange !== undefined && question.questionSetAnswerType.endRange !== "" && question.questionSetAnswerType.endRange !== null && question.questionSetAnswerType.endRange !== undefined) {
        function pad(s: any) { return (s < 10) ? '0' + s : s; }
        let startDate = new Date(question.questionSetAnswerType.startRange);
        let endDate = new Date(question.questionSetAnswerType.endRange);
        const formattedStartRange = [pad(startDate.getDate()), pad(startDate.getMonth() + 1), startDate.getFullYear()].join('-');
        const formattedEndRange = [pad(endDate.getDate()), pad(endDate.getMonth() + 1), endDate.getFullYear()].join('-');

        validationMessage = validationMessage + " between " + formattedStartRange + " & " + formattedEndRange;
    }

    var inputClasses = classNames(
        {
            'date-text': true,
            'validation-fail': question.validationFail
        }
    );

    var labelClasses = classNames(
        {
            'validation-fail-lbl': question.validationFail
        }
    );


    useEffect(() => {
        setQuestion(props.question);
        if (props.question.answer) {
            setDayValue(props.question.answer.substr(8, 2));
            setMonthValue(props.question.answer.substr(5, 2));
            setYearValue(props.question.answer.substr(0, 4));
        }
        setPageLoaded(true);
    }, []);

    useEffect(() => {
        if (secondsFocused === 60) {
            //alert("Too much time has passed");
            //alert(question.questionSetQuestion.text);
        }
    }, [secondsFocused]);

    useEffect(() => {
        question.answer = dateValue;
        setQuestion(question);
        props.setIndividualCustomerDetails(question);
        props.enableQuestions(question.questionSetQuestion.questionID);
        if (pageLoaded) {
            setDateValueUpdated(true);
        }
        
    }, [dateValue])

    useEffect(() => {
        if (dateValueUpdated && pageLoaded) {
            tracking(Action.SAVE_QUESTIONS, question.questionSetQuestion.questionID);
            question.validationFail = !questionValidation(question);
            setQuestion(question);
            setDateValueUpdated(false);
        }
    }, [dateValueUpdated])

    const startTimer = () => {
        timerId.current = window.setInterval(() => {
            setSecondsFocused(prev => prev + 1);
        }, 1000)
    };

    const stopTimer = () => {
        window.clearInterval(timerId.current);
        setSecondsFocused(0);
    };

    const updateDay = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDayValue(e.target.value);
    };

    const updateMonth = (e: React.ChangeEvent<HTMLInputElement>) => {
        setMonthValue(e.target.value);
    };

    const updateYear = (e: React.ChangeEvent<HTMLInputElement>) => {
        setYearValue(e.target.value);
    };

    const validateAnswer = () => {
        stopTimer();
        let policyDayValue = dayValue;
        let policyMonthValue = monthValue;
        let policyYearValue = yearValue;
        if (dayValue.length === 1) {
            setDayValue("0" + dayValue);
            policyDayValue = "0" + policyDayValue;
        }

        if (monthValue.length === 1) {
            setMonthValue("0" + monthValue);
            policyMonthValue = "0" + policyMonthValue;
        }

        if (yearValue.length === 2) {
            let currentYear = new Date().getFullYear().toString().substr(2, 2);
            if (parseInt(yearValue) <= parseInt(currentYear)){
                setYearValue("20" + yearValue);
                policyYearValue = "20" + policyYearValue;
            } else {
                setYearValue("19" + yearValue);
                policyYearValue = "19" + policyYearValue;
            }
            
        }

        if (policyDayValue.length === 2 && policyMonthValue.length === 2 && policyYearValue.length === 4) {
            var dateAnswer = policyYearValue + "-" + policyMonthValue + "-" + policyDayValue;
            setDateValue(dateAnswer);
        }
    };

    return (
        <>
            <div className="question">
                <label className={labelClasses} htmlFor={"valen_" + question.questionSetQuestion.questionID}>{question.questionSetQuestion.text}</label>
                <br />
                <input
                    type="text"
                    value={dayValue}
                    id={"valen_day_" + question.questionSetQuestion.questionID}
                    className={inputClasses}
                    onChange={(e) => updateDay(e)}
                    onFocus={() => startTimer()}
                    onBlur={() => validateAnswer()}
                    placeholder="DD"
                    maxLength={2}
                />
                <span> - </span>
                <input
                    type="text"
                    value={monthValue}
                    id={"valen_month_" + question.questionSetQuestion.questionID}
                    className={inputClasses}
                    onChange={(e) => updateMonth(e)}
                    onFocus={() => startTimer()}
                    onBlur={() => validateAnswer()}
                    placeholder="MM"
                    maxLength={2}
                />
                <span> - </span>
                <input
                    type="text"
                    value={yearValue}
                    id={"valen_year_" + question.questionSetQuestion.questionID}
                    className={inputClasses}
                    onChange={(e) => updateYear(e)}
                    onFocus={() => startTimer()}
                    onBlur={() => validateAnswer()}
                    placeholder="YYYY"
                    maxLength={4}
                />
                {question.questionSetQuestion.helpText !== null && question.questionSetQuestion.helpText !== "" &&
                    <QuestionHelp helpText={question.questionSetQuestion.helpText} questionID={question.questionSetQuestion.questionID} />
                }
                {question.validationFail &&
                    <ValidationMessage question={question} overrideMessage={validationMessage} />}
                {/*<p>Focused: {secondsFocused}</p>*/}
            </div>
        </>

    );
};